import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/AuthService';
import { OutdatedBay } from 'src/app/shared/services/launcher-update-guard.service';

@Component({
  selector: 'app-launcher-update-modal',
  templateUrl: './launcher-update-modal.component.html',
  styleUrls: ['./launcher-update-modal.component.scss'],
})
export class LauncherUpdateModalComponent {
  readonly requiredVersion = environment.sseLauncherVersion;
  checking = false;

  constructor(
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      bays$: Observable<OutdatedBay[]>;
      checking$: Observable<boolean>;
      refresh: () => Promise<void>;
    },
  ) {}

  async refresh(): Promise<void> {
    if (this.checking) {
      return;
    }
    this.checking = true;
    try {
      await this.data.refresh();
    } finally {
      this.checking = false;
    }
  }

  signOut(): void {
    this.authService.unautorized().then(() => {
      window.location.reload();
    });
  }
}
